import { getIconPath } from "../../utilities/textUtilities";

export interface IInstrument {
  id: number;
  name: string;
  instrumentType: string;
  productType: string;
  productName: string;
  calendarMonthOffset: number;
  companyIds: number[];
  isSellable: boolean;
  selectable(id: number): boolean;
}

export class Instrument implements IInstrument {
  id = 0;
  name = "";
  instrumentType = "";
  productType = "";
  productName = "";
  calendarMonthOffset = 0;
  companyIds: number[] = [];
  isSellable = false;

  private constructor(instrument: IInstrument | null | undefined) {
    if (instrument) {
      this.id = instrument.id;
      this.name = instrument.name;
      this.instrumentType = instrument.instrumentType;
      this.productType = instrument.productType;
      this.productName = instrument.productName;
      this.calendarMonthOffset = instrument.calendarMonthOffset;
      this.companyIds = instrument.companyIds;
      this.isSellable = instrument.isSellable;
    }
  }

  static get EMPTY(): Instrument {
    return Instrument.create(null);
  }

  static create(obj: IInstrument | null | undefined): Instrument {
    return new Instrument(obj);
  }

  public icon = () => getIconPath("instrument", this.productType);

  public isInsurance = () => this.productType.toLowerCase() === "insurance";
  public isAccumulator = () => this.instrumentType.toLowerCase() === "accumulator";

  public selectable = (id: number) => this.companyIds.includes(id);

  public quoteType = () => {
    let quoteType = "vanilla";
    if (this.isInsurance()) quoteType = this.productType.toLowerCase();
    else if (this.isAccumulator()) quoteType = this.instrumentType.toLowerCase();

    return quoteType;
  };
}
